import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainSideColumn from "../../Components/sidebars/MainSideColumn";
import ChildSideColumn from "../../Components/sidebars/ChildSideColumn";
import "../products/product.scss";
import { DIRECT_CARDS, INDUSTRIES } from "./constant";
import { hide, setActiveIndex } from "../../redux/SideBarSlice";
import { motion, AnimatePresence } from "framer-motion";
import { close } from "../../helpers/constant/imageUrl";
import { setNav_Item } from "../../redux/NavBarSlice";
import RightContentColumn from "../../Components/sidebars/RightContentColumn ";
import { useLocation } from "react-router-dom";

const Industry = () => {
  const visible = useSelector((state) => state.sidebarItem.visible);
  const source = useSelector((state) => state.sidebarItem.source);
  console.log("Redux state:", { visible, source });

  const activeIndex = useSelector((state) => state.sidebarItem.activeIndex);
  const suppressHighlight = useSelector(
    (state) => state.sidebarItem.suppressHighlight,
  );
  const dispatch = useDispatch();

  const getActiveCards = () => {
    if (activeIndex === null) return DIRECT_CARDS;
    const activeItem = INDUSTRIES[activeIndex];
    if (!activeItem) return [];

    const hasSegments = activeItem.segments?.length > 0;

    console.log();

    return hasSegments ? activeItem.cards || DIRECT_CARDS : DIRECT_CARDS;
  };

  console.log("cards from industry", getActiveCards());

  function handleProductClick(index) {
    dispatch(setActiveIndex(index));

    if (index === 8) {
      dispatch(hide());
    }
  }
  // function handleProductClick(index) {
  //   setActiveIndex(index);
  // }

  const state = useSelector((state) => state.sidebarItem);
  console.log("Current state:", state);

  return (
    <>
      {visible && source === "industries" && (
        <div className={`product-container`}>
          <MainSideColumn
            products={INDUSTRIES}
            activeIndex={activeIndex}
            suppressHighlight={suppressHighlight}
            onProductClick={handleProductClick}
            title="Industries"
          />

          {activeIndex !== null && !suppressHighlight && (
            <>
              {/* Segment Column - only when user has selected an item */}
              {INDUSTRIES[activeIndex]?.segments?.length > 0 && (
                <ChildSideColumn
                  className="software-column"
                  title="Segments"
                  items={INDUSTRIES[activeIndex].segments.map(
                    (segment) => segment,
                  )}
                />
              )}
            </>
          )}

          {/* RIGHT – Cards */}
          <RightContentColumn
            cards={getActiveCards()}
            // limit={
            //   activeIndex !== null &&
            //   !suppressHighlight &&
            //   INDUSTRIES[activeIndex]?.segments?.length > 0
            //     ? 4
            //     : null
            // }
          />
        </div>
      )}
    </>
  );
};

export default Industry;
